import { motion } from "framer-motion";

export function ExperienceChart() {

  return (
    <div
      className="h-full rounded-2xl item-border border-white/10 bg-gradient-to-br from-white/5 to-transparent backdrop-blur-sm p-6 md:p-8"
    >
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
        className="text-center text-[#D4B896] text-sm mb-8"
      >
        Participants: 21 Members
      </motion.p>

      <div className="relative">
        {/* Chart container */}
        <div className="flex items-end justify-around h-64 md:h-72 pl-12 border-b border-l border-gray-600 relative">
          <img
            src="/assets/imgs/case-studies/ipm_3.png"
            alt="Experience Chart"
            className="w-full h-auto"
          />
        </div>
      </div>
    </div>
  );
}
